import type { TranslationDict } from './ja'

export const id: TranslationDict = {
  appTitle: 'Lucky Animal Territory',
  help: 'Cara bermain',
  helpAria: 'Cara bermain',
  settings: 'Pengaturan',
  settingsAria: 'Pengaturan',
  close: 'Tutup',
  closeAria: 'Tutup',
  player: 'Pemain',
  highscore: 'Skor Tertinggi',
  start: 'Mulai',
  staminaEmpty: 'Stamina tidak cukup',
  ranking: 'Perang Wilayah',
  difficultyTitle: 'Pilih kesulitan',
  difficultyStart: 'Mulai dengan tingkat ini',
  back: 'Kembali',
  today: 'Hari ini',
  weekly: 'Minggu ini',
  alltime: 'Total',
  loading: 'Memuat...',
  noScores: 'Belum ada skor. Jadilah juara wilayah pertama!',
  loadFailed: 'Gagal memuat',
  you: 'Kamu',
  youConstant: 'KAMU',
  language: 'Bahasa',
  languageNote: 'Mendukung 18 bahasa termasuk Jepang.',
  bgm: 'BGM',
  se: 'Efek suara',
  soundEnableAria: 'Nyalakan suara',
  soundDisableAria: 'Matikan suara',
  adWatch: 'Tonton iklan sampai selesai',
  adCancel: 'Nanti saja',
  rankSuffix: '',
  earnedPoints: 'mendapat {score} pt',
  helpGoalTitle: '🎯 Tujuan',
  helpGoalText: 'Letakkan bidak pada papan 9x9 dan perluas wilayah yang terhubung. Skor tertinggi akan menang.',
  helpWinTitle: '🏆 Kondisi menang',
  helpWinFive: 'Buat lima bidak sejajar secara vertikal, horizontal, atau diagonal untuk kemenangan instan.',
  helpWinScore: 'Jika papan penuh, skor tertinggi akan menang. Tidak ada hasil seri.',
  helpScoreTitle: '💯 Skor',
  helpLineBonus: 'Bonus garis: dapatkan poin untuk 3, 4, dan 5 bidak sejajar.',
  helpClusterBonus: 'Bonus wilayah: skor meningkat seiring besarnya kelompok yang terhubung.',
  helpKomi: 'Komi: pemain kedua mendapatkan tambahan skor +10% sebagai handicap.',
  helpControlsTitle: '🖱️ Kontrol',
  helpControlsText: 'Saat giliranmu, ketuk sel kosong untuk meletakkan bidak.',
  helpTipsTitle: '💡 Tip',
  helpTipHell: 'Coba mode HELL jika kamu ingin tantangan terberat.',
  helpTipCluster: 'Jangan hanya mengejar lima sejajar. Kelompok terhubung yang besar juga meningkatkan skormu.',
  resultWinFive: '🎉 Lima sejajar! Kamu menang!',
  resultWinScore: '🎉 Menang skor! Kamu menang!',
  resultLoseFive: '😿 CPU berhasil membuat lima sejajar!',
  resultLoseScore: '😿 Kalah skor. Coba lagi!',
  resultDraw: '🤝 Seri',
  newHighscore: '🏆 Skor tertinggi baru!',
  scoreNone: 'Belum ada skor',
  clusterBonus: 'Bonus wilayah',
  retry: 'Main lagi',
  titleBack: 'Judul',
  scoreHintPlaceStone: 'Letakkan batu',
  best: 'Terbaik',
  clusterUnit: 'wilayah',
  lineCount: '{len} sejajar x{count}',
  turnCount: 'Langkah {count} · {difficulty}',
  boardPlayerPiece: 'Bidakmu',
  boardCpuPiece: 'Bidak CPU',
  boardPlayerAlt: 'Kamu',
  boardCpuAlt: 'CPU',
  boardCellPosition: 'baris {row}, kolom {col}',
  boardPlaceable: 'bisa diletakkan',
  boardEmpty: 'sel kosong',
  boardFlower: 'ada bunga',
  firstPlayerAlt: 'Pemain pertama',
  playerFirst: 'Kamu jalan duluan!',
  playerSecond: 'Kamu jalan kedua (+{bonus}% komi)',
  cpuFirst: 'CPU jalan duluan!',
  finalePlayerWin: 'Kamu menang!',
  finaleCpuWin: 'CPU menang!',
  finaleFive: 'Lima sejajar!',
  finaleTerritory: 'Perang wilayah!',
  winnerAlt: 'Pemenang',
  loadingBoot: 'Memulai...',
  loadingConnect: 'Menghubungkan...',
  loadingProfile: 'Memuat profil...',
  loadingAssets: 'Memuat aset...',
  loadingReady: 'Siap',
  reauthRequiredTitle: 'Perlu login',
  startupFailedTitle: 'Gagal memulai',
  reauthButton: 'Login lagi',
  reloadButton: 'Muat ulang',
  lineReloginButton: 'Login LINE',
  reauthReason: 'Sesi login telah berakhir. Silakan login kembali.',
  errorReauth: 'Sesi login telah berakhir. Silakan login kembali.',
  errorForbidden: 'Kamu tidak memiliki izin untuk memainkan game ini.',
  errorNotFound: 'Data game tidak ditemukan.',
  errorRateLimited: 'Jaringan sibuk. Harap tunggu dan coba lagi.',
  errorServer: 'Tidak dapat terhubung ke server. Harap tunggu dan muat ulang.',
  errorCommunication: 'Terjadi kesalahan komunikasi. Harap muat ulang.',
  errorNetwork: 'Tidak dapat terhubung ke jaringan. Periksa koneksi dan muat ulang.',
  errorStartup: 'Gagal memulai. Harap muat ulang.',
  settingsTabGeneral: 'Pengaturan',
  settingsTabAccount: 'Akun',
  settingsTabInfo: 'Info',
  account: 'Akun',
  linked: 'Tersambung',
  guest: 'Tamu',
  loggedInWith: 'Login dengan {provider}',
  loggedIn: 'Sudah login',
  playingAsGuest: 'Kamu saat ini bermain sebagai tamu.',
  appleLoginBusy: 'Sedang login dengan Apple...',
  appleLogin: 'Login dengan Apple',
  googleLoginBusy: 'Sedang login dengan Google...',
  googleLogin: 'Login dengan Google',
  logoutBusy: 'Sedang logout...',
  logout: 'Logout',
  logoutSuccess: 'Berhasil logout',
  logoutFailed: 'Gagal logout',
  appInfo: 'Informasi aplikasi',
  appName: 'Nama aplikasi',
  version: 'Versi',
  legalInfo: 'Informasi hukum',
  terms: 'Syarat Penggunaan',
  privacy: 'Kebijakan Privasi',
  operator: 'Operator',
  contact: 'Kontak',
  copyTap: 'Ketuk untuk menyalin',
  idCopied: 'ID disalin',
  copyFailed: 'Gagal menyalin',
  other: 'Lainnya',
  reportAd: 'Laporkan iklan tidak pantas',
  privacyChoices: 'Ad privacy choices',
  profileEdit: 'Edit profil',
  displayName: 'Nama tampilan',
  displayNamePlaceholder: 'Masukkan nama',
  chooseIcon: 'Pilih ikon',
  iconLoadFailed: 'Gagal memuat daftar ikon.',
  saveFailed: 'Gagal menyimpan. Silakan coba lagi.',
  noIcons: 'Ikon tidak tersedia.',
  save: 'Simpan',
  saving: 'Menyimpan...',
  staminaAria: 'Stamina {stamina} / {max}',
  nextRecovery: 'Pemulihan berikutnya dalam {time}',
  adPlaying: 'Memutar iklan...',
  recoverFullAd: 'Tonton iklan untuk memulihkan stamina penuh',
  dailyBonusAria: 'Tonton iklan sampai selesai untuk stamina +5',
  dailyBonusAd: 'Tonton iklan untuk stamina +5',
  legalLastUpdated: 'Terakhir diperbarui: {date}',
  privacyTitle: 'Kebijakan Privasi',
  termsTitle: 'Syarat Penggunaan',
  adPlayingAria: 'Iklan sedang diputar',
  adBadge: '▶ Iklan',
  adRemaining: 'Sisa {seconds} detik',
  adDevHint: 'Iklan uji coba pengembangan. Di versi rilis, video AdMob akan diputar.',
  adRewardRequirement: 'Tonton iklan sampai selesai untuk menerima hadiah ini.',
  adRewardStaminaDetail: 'Hadiah: stamina dipulihkan hingga maksimum',
  adRewardDailyBonusDetail: 'Hadiah: stamina +{amount} sebagai bonus harian',
  adRewardIncompleteNote: 'Jika ditutup sebelum selesai, hadiah tidak diterima.',
  adSkipAria: 'Lewati iklan',
  adSkip: 'Lewati ✕',
  adSkipAfter: 'Lewati dalam {seconds} detik',
  offlineMessage: 'Tidak dapat terhubung ke server. Beberapa fitur mungkin tidak tersedia.',
  reconnecting: 'Menghubungkan kembali...',
  reconnect: 'Hubungkan kembali',
  signInTitle: 'Sign in',
  signInBusy: 'Sedang sign in...',
  signInCancelNote: 'Jika kamu membatalkan sign in, kamu bisa tetap bermain sebagai tamu (beberapa fitur terbatas).',
  processing: 'Memproses...',
  recoverConfirmTitle: 'Konfirmasi penimpaan data',
  recoverConfirmMessage: 'Data yang ada sudah tertaut ke login ini. Melanjutkan akan menimpa data tamu di perangkat ini. Apakah kamu ingin melanjutkan?',
  recoverConfirmContinue: 'Pulihkan',
  recoverConfirmCancel: 'Batal',
  unlinkConfirmTitle: 'Putus tautan akun',
  unlinkConfirmMessage: 'Jika kamu memutus tautan dari penyedia ini, perangkat ini akan kembali ke mode tamu. Data Hub tetap tersedia jika kamu login kembali dengan penyedia yang sama di perangkat lain.',
  unlinkConfirmContinue: 'Putus tautan',
  unlinkConfirmCancel: 'Batal',
  deleteConfirmTitle: 'Konfirmasi penghapusan akun',
  deleteConfirmMessage: 'Menghapus akun akan menghapus skor tertinggi, data login, akun tertaut, dan undangan.\nTindakan ini tidak bisa dibatalkan. Kamu yakin ingin menghapusnya?',
  deleteConfirmContinue: 'Hapus akun',
  deleteConfirmCancel: 'Batal',
  adNekoTitle: 'AD Neko',
  matchmakingRemaining: 'Sisa {seconds} detik',
  matchmakingTimeoutMessage: 'Tidak menemukan lawan dalam waktu yang ditentukan. Silakan coba lagi.',
  difficultyEasyName: 'Santai',
  difficultyEasyDescription: 'Lawan sedikit tidak fokus',
  difficultyNormalName: 'Normal',
  difficultyNormalDescription: 'Lawan terkadang melakukan kesalahan',
  difficultyHardName: 'Sulit',
  difficultyHardDescription: 'Lawan memiliki pandangan luas terhadap papan',
  difficultyHellName: 'Ekstrem',
  difficultyHellDescription: 'Lawan sangat kuat dan pandai memprediksi langkah',
}
